import request from 'src/shared/utils/requester';

const USE_CASE_URL = 'customer-invoices';

const getCustomerInvoiceById = async (id) => {
  const method = 'GET';
  const url = `${USE_CASE_URL}/${id}`;

  const json = await request({ method, url });
  return json;
};

export default getCustomerInvoiceById;
